import React from 'react';
import { Box, Typography } from '@mui/material';

const MoreNewsButton = ({ onClick }) => (
    <Box sx={{ textAlign: 'center', mt: 8 }}>
        <Typography
            variant="h5"
            onClick={onClick}
            sx={{
                display: 'inline-block',
                bgcolor: '#f39c12',
                color: 'white',
                p: '8px 16px',
                borderRadius: '20px',
                cursor: 'pointer',
                '&:hover': {
                    bgcolor: '#e67e22',
                },
            }}
        >
            More News
        </Typography>
    </Box>
);

export default MoreNewsButton;
